import React from 'react';
import ReportingMarketingAttributionPage from '../components/ReportingMarketingAttributionPage';

const axios = require('axios').default;

const ReportingMarketingAttributionApp = (props) => {
  if (props.csrfToken) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = props.csrfToken;
  }
  return <ReportingMarketingAttributionPage {...props} />;
};

export default ReportingMarketingAttributionApp;
